/*
 * Custom syntaxes that we want to support that are not supported in the main prismjs package.
 */
export const customPrismSyntaxes = {
    prisma: () => import('./prisma'),
};
